import { skipToken } from '@reduxjs/toolkit/query';
import { BenefitType, BenefitTypes } from '@strata/constants';

import { ProductConfig, useGetProductConfigForPayerQuery } from 'store/api/referenceApi';

export const useProductConfig = ({
    segmentId,
    productServiceOid,
    benefit,
}: {
    segmentId?: string;
    productServiceOid?: string;
    benefit?: BenefitType;
}) => {
    const { data } = useGetProductConfigForPayerQuery(
        segmentId && productServiceOid ? { segmentId, productServiceOid } : skipToken,
    );
    return data?.find((config) => config.preferredBillingType === benefit);
};

/** Gets proper display units for the est dispensed quantity value  */
export const getEstDispensedQtyUnits = (productConfig?: ProductConfig) => {
    if (productConfig?.preferredBillingType === BenefitTypes.MEDICAL) {
        return productConfig.hcpcsBillingLabel;
    }
    if (productConfig?.preferredBillingType === BenefitTypes.PHARMACY) {
        return productConfig.ndcBillingLabel;
    }
    return undefined;
};

/** Adds display units to the quantity values */
export const addQtyUnits = (qty: number | string | undefined, units: string | undefined) =>
    qty && `${qty}${units ? ` ${units}` : ''}`;
